export class GradeModle {
  feedback: string;
  marks: number;
  out_of: number;
  graded_by: string;

  constructor() {}
}
